"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateUiSchema = exports.validatePhone = exports.validateEmail = exports.transformFormErrors = void 0;
const validateUiSchema = (schema, uiSchema) => {
  const uiObj = Object.keys(uiSchema).filter(ui => {
    return !ui.startsWith("ui");
  });
  const found = Object.keys(schema?.properties).every(r => uiObj.indexOf(r) >= 0);
  if (!found) {
    console.error("Incorrect Ui schema!");
  }
};
exports.validateUiSchema = validateUiSchema;
const validateEmail = email => {
  const regex = /\S+@\S+\.\S+/;
  return regex.test(email);
};
exports.validateEmail = validateEmail;
const validatePhone = phone => {
  const regex = /^[0-9()+\- ]*$/;
  return regex.test(phone);
};
exports.validatePhone = validatePhone;
const transformFormErrors = errors => {
  const errorMessages = errors.map(error => {
    let message = "";
    if (error.name === "pattern") {
      message = "Only numbers are allowed.";
    } else if (error.name === "required") {
      message = "Can't be blank.";
    } else if (error.name === "minLength") {
      message = `Must have ${error.params?.limit} characters/digits.`;
    }
    return message;
  });
  const errorObject = errors?.length > 0 && errorMessages?.join("") ? [{
    ...errors?.[0],
    message: errorMessages.join(" ")
  }] : errors;
  return errorObject;
};
exports.transformFormErrors = transformFormErrors;